import React, {Component} from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { createLoginRequest } from "../../../actions/loginAction";
import validateInput from "../../Validations/Signin";
import {ToastsContainer, ToastsStore, ToastsContainerPosition} from 'react-toasts';
import {fetchCountryList, fetchStateList, fetchCityList, fetchProfileIDList, fetchProfileProfessionList } from "../../../actions/commonAction";
import { basicRegistrationRequest, goldRegistrationRequest, otoVerification, resendotpRequest, resendemailotpRequest} from "../../../actions/loginAction";
import { bindActionCreators } from 'redux';
import { withRouter } from "react-router-dom";
import pathList from "../../../helpers/pathList";
import { getlanguagelist } from "../../../helpers/changelanguage";
import { getPublicIP } from "../../../helpers/authHelper";
import AutoComplete   from "../../Common/countryDropdown";
import StateDropdown   from "../../Common/stateDropdown";
import CityDropdown from "../../Common/cityDropdown";
import IdtypeDropdown from "../../Common/idtypeDropdown";
import ProfessionDropdown from "../../Common/professionDropdown";
import VerifyOtp from "../otpverify";
import {validatesignupInput} from "../../Validations/Signin";

class RegistrationForm extends Component {
  constructor(props){
    super(props);
    this.state = {
      first_name            : '',
      last_name             : '',
      title                 : '',
      gender                : '',
      phone                 : '',
      password              : '',
      countryList           : [],
      stateList             : [],
      cityList              : [],
      country_code          : '',
      country_name          : '',
      country_id            : '',
      country_dial_code     : '00',
      country_flag_code     : '',
      is_country_change     : 0,
      state_id              : '',
      state_name            : '',
      city_id               : '',
      city_name             : '',
      zipcode               : '',
      address               : '',
      email                 : '',
      id_type               : '',
      id_type_id            : '',
      id_type_value         : '',
      idList                : [],
      professionList        : [],
      work_title            : '',
      work_title_id         : '',
      work_position         : '',
      otpmodal              : false,
      membership            : (window.location.href.includes('gold') == true) ?  'GOLD' : 'BASIC',
      url_membership        : (window.location.href.includes('gold') == true) ?  'GOLD' : 'BASIC',
      user_id               : null
    };
    this.onSubmit         = this.onSubmit.bind(this);
    this.handleChange     = this.handleChange.bind(this);
    this.fetchCountry     = this.fetchCountry.bind(this);
    this.fetchState       = this.fetchState.bind(this);
    this.fetchCity        = this.fetchCity.bind(this);
    this.changeCountry    = this.changeCountry.bind(this);
    this.changeState      = this.changeState.bind(this);
    this.changeCity       = this.changeCity.bind(this);
    this.onOtpClose       = this.onOtpClose.bind(this);
    this.onOtpSubmit      = this.onOtpSubmit.bind(this);
    this.resend           = this.resend.bind(this);
    this.fetchId          = this.fetchId.bind(this);
    this.fetchProfession  = this.fetchProfession.bind(this);
    this.changeId         = this.changeId.bind(this);
    this.changeProfession  = this.changeProfession.bind(this);
  }
  componentDidMount() {
    this.fetchCountry();
    if(this.state.membership == 'GOLD'){
      this.fetchProfession();
    }
  }
  fetchCountry(){
    this.props.fetchCountryList();
  }
  fetchState(countryId){
    this.props.fetchStateList(countryId);
  }
  fetchCity(stateId){
    this.props.fetchCityList(stateId);
  }
  fetchId(countryId){
    this.props.fetchProfileIDList(countryId);
  }
  fetchProfession(){
    this.props.fetchProfileProfessionList();
  }

  changeCountry(countryData){
    this.setState({
       country_code          :  countryData.country_code,
       country_name          :  countryData.country_name,
       country_id            :  countryData.country_id,
       country_dial_code     :  countryData.country_dial_code,
       country_flag_code     :  countryData.country_flag_code,
       is_country_change     :  1,
       state_id              :  '',
       state_name            :  '',
       city_id               :  '',
       city_name             :  '',
       zipcode               :  '',
     }) ;
     this.fetchState(countryData.country_code); 
     if(this.state.membership == 'GOLD'){
      this.fetchId(countryData.country_code);
     }
  }

  changeState(stateData){
    this.setState({
      is_country_change     :  1,
      state_id              :  stateData.id,
      state_name            :  stateData.name,
      city_id               :  '',
      city_name             :  '',
      zipcode               :  '',
     })  
    this.fetchCity(stateData.id);
  }

  changeCity(cityData){
    this.setState({
      is_country_change     :  1,
      city_id               :  cityData.id,
      city_name             :  cityData.name,
      zipcode               :  '',
    })  
  }
  changeId(idData){
    this.setState({
      id_type             : idData.id_type,
      id_type_id          : idData.id_type_id,
      id_type_value       : '',
    }) 
  }

 changeProfession(professionData){
  this.setState({
      work_title            : professionData.work_title,
      work_title_id         : professionData.work_title_id,
      work_position         : ''
  })
   
 }
 onSubmit(e){
  e.preventDefault();
  if(this.state.membership == 'BASIC'){
    let param = {
      first_name:this.state.first_name,
      last_name:this.state.last_name,
      email       : this.state.email,
      /*phone:this.state.phone,*/
      password:this.state.password,
      zipcode:this.state.zipcode,
      address:this.state.address,
      country:this.state.country_code,
      gender:this.state.gender,
      device:'WEB',
      device_token:getPublicIP(),
      country_flag: this.state.country_flag_code,
      country_code: this.state.country_dial_code,
      state:this.state.state_id,
      city:this.state.city_id,
      zipcode:this.state.zipcode
    }
    let { error, isValid } = validatesignupInput(param);
    if (isValid) {
      this.props.basicRegistrationRequest(param);
    }else{
      ToastsStore.error(error.message);
    }
  }else{

    let param = {
      title       : this.state.title,
      first_name  : this.state.first_name,
      last_name   : this.state.last_name,
     /* phone       : this.state.phone,*/
      password    : this.state.password,
      zipcode     : this.state.zipcode,
      address     : this.state.address,
      country     : this.state.country_code,
      gender      : this.state.gender,
      device      : 'WEB',
      device_token: getPublicIP(),
      country_flag: this.state.country_flag_code,
      country_code: this.state.country_dial_code,
      state       : this.state.state_id,
      city        : this.state.city_id,
      zipcode     : this.state.zipcode,
      id_type     : this.state.id_type_id,
      id_number   : this.state.id_type_value,
      work        : this.state.work_title_id,
      position    : this.state.work_position,
      career      : this.state.career,
      email       : this.state.email
     
    }
    
     let { error, isValid } = validatesignupInput(param);
    if (isValid) {
      this.props.goldRegistrationRequest(param);
    }else{
      ToastsStore.error(error.message);
    } 

  }
  
 }

  onOtpSubmit(emailotp){
    
    let param = {
      membership  : '',//this.state.url_membership,
      user_id     : this.state.user_id,
      otp         : emailotp
    }
    /* if(this.state.url_membership == 'GOLD'){
      Object.assign(param, {
        email_otp : emailotp
      })
    } */
    this.props.otoVerification(param);
  }

  onOtpClose(){
    this.setState({
      otpmodal    : false
    })
  }

  resend(type){
    if(type == 'mobile'){
      let param = {
        phone  : this.state.phone
      }
      this.props.resendotpRequest(param);
    }else{
      let param = {
        email  : this.state.email
      }
      this.props.resendemailotpRequest(param);
    }
  }

  handleChange(e) {
    this.setState({
      [e.target.name]: e.target.value,
    });
  }
  UNSAFE_componentWillReceiveProps(nextProps,prevProps){
    if((nextProps.countryList != null) || (this.state.is_country_change == 1)){
      this.setState({
          countryList : nextProps.countryList
      })
    }
    if((nextProps.stateList != null) || (this.state.is_country_change == 1)){
      this.setState({
          stateList : nextProps.stateList
      })
    }
    if((nextProps.cityList != null) || (this.state.is_country_change == 1)){
      this.setState({
          cityList : nextProps.cityList
      })
    }
    if(nextProps.registration != this.props.registration){
      if(nextProps.registration.req_status == false){
          ToastsStore.error(nextProps.registration.req_message);
      }else{
          ToastsStore.success(nextProps.registration.req_message);
          this.setState({
            otpmodal   : true,
            membership : nextProps.registration.membership,
            user_id    : nextProps.registration.user_id
          });
      }
    }

    if(nextProps.otp != this.props.otp)
    {
      if(nextProps.otp.req_status == true){
        
          ToastsStore.success(nextProps.otp.req_message);
          this.setState({
            otpmodal    : false
          })
          console.log(this.state.membership);
          console.log('=========Next Props===============');
          console.log(nextProps.otp);
        //if(this.state.membership == 'BASIC'){
        if(nextProps.otp.membership == 'BASIC' && nextProps.otp.membership_upgrade_status == 'BASIC'){
          //localStorage.setItem('login', 1);
          ToastsStore.success('Your email id is successfully verified.');
          this.props.history.push(pathList.feed.path);
        }else{
          //window.location.reload();
          //thank u popup 
          let curlang = (localStorage.getItem('userLanguage') == undefined) ? 'so' : localStorage.getItem('userLanguage');
              if(curlang == 'en'){
                $("#thanku").html('<h2>Thank You</h2><span>for your submission.</span><div class="clr25"></div><p>Your account is pending for approval from <br/>Administrator. We hope to see you soon with us.</p>');
                $("#thank_btn").html('Close');
              }else{
                $("#thanku").html('<h2>Waad ku</h2><span>mahadsan tahay soo gudbintaada.</span><div class="clr25"></div><p>Dalabkaaga wuxuu ansixin ka sugayaa maamulka <br/>BD. Waxaan kuu rajeyneynaa in si deg deg ah laguugu aqbalo.</p>');
                $("#thank_btn").html('Xir');
              }
          $("#myModal").modal()
        }
      }else{
         ToastsStore.error(nextProps.otp.req_message);
      }
      
    }
    if(nextProps.resend != this.props.resend){
      if(nextProps.resend.req_status == true){
        ToastsStore.success(nextProps.resend.req_message);
      }else{
        ToastsStore.error(nextProps.otp.req_message);
      }

    }

    if(nextProps.idList != null){
      this.setState({
          idList : nextProps.idList
      })
    }
    if(nextProps.professionList != null){
        this.setState({
            professionList : nextProps.professionList
        })
    }
  }
  render() {
    let  languagelist    = getlanguagelist();
    return (
      <div className="col-lg-5">
          <div className="login_reg_box">

              <div className="login_box" >
                <h2 className="reg-heading"> 
                {
                  window.location.href.includes('basic') ? languagelist.basicm  : languagelist.goldm
                }
               
                </h2>
              </div>
              <form id="signup-form" onSubmit={this.onSubmit}>
              <ToastsContainer store={ToastsStore} position={ToastsContainerPosition.TOP_CENTER} lightBackground />
              <div className="reg_box">
                  { (this.state.membership == "GOLD") ? 
                      <div className="input-icon">
                        <img className="icon" src="/assets/images/r_user.png" />
                        <select className="form-control" name="title" value={this.state.title} onChange={this.handleChange}>
                          <option value="" >{languagelist.title}</option>
                          <option value="Mr." >{languagelist.mr}</option>
                          <option value="Ms." >{languagelist.ms}</option>
                          <option value="Mrs." >{languagelist.mrs}</option>
                          <option value="Dr." >{languagelist.dr}</option>
                          <option value="Prof." >{languagelist.prof}</option>
                      </select>
                      </div> 
                    : null
                  }

                  <div className="input-icon">
                      <img className="icon" src="/assets/images/r_user.png" />
                      <input type="text" placeholder={languagelist.fname} name="first_name" value={this.state.first_name} onChange={this.handleChange} /> 
                  </div>

                  <div className="input-icon">
                      <img className="icon" src="/assets/images/r_user.png" />
                      <input type="text" placeholder={languagelist.lname} name="last_name" value={this.state.last_name} onChange={this.handleChange}/>
                  </div>


                  
                  <div className="input-icon">
                      <img className="icon" src="/assets/images/r_gender.png" />
                      {/* <input type="text" placeholder="Gender" /> */}
                      <select className="form-control" name="gender" value={this.state.gender} onChange={this.handleChange} >
                          <option value="" >{languagelist.gender}</option>
                          <option value="F" >{languagelist.female}</option>
                          <option value="M" >{languagelist.male}</option>
                          <option value="T" >{languagelist.otherg}</option>
                      </select>
                  </div>
                
                  <div className="input-icon">
                      <img className="icon" src="/assets/images/r_password.png" />
                      <input type="password" placeholder={languagelist.password} name="password" value={this.state.password} onChange={this.handleChange}/>
                  </div>

                  
                  <div className="input-icon">
                      <img className="icon" src="/assets/images/r_cuntry.png" />
                      {/* <input type="text" placeholder="Country" /> */}
                      <AutoComplete dataList={this.state.countryList} defaultVal = {this.state.country_name} changeCountry={this.changeCountry}/>
                  </div>

                  <div className="input-icon">
                      <img className="icon" src="/assets/images/r_state.png" />
                      {/*  <input type="text" placeholder="Region / Province / State" /> */}
                      <StateDropdown dataList={this.state.stateList} defaultVal = {this.state.state_name} changeState={this.changeState}/>
                  </div>

                  <div className="input-icon">
                      <img className="icon" src="/assets/images/r_city.png" />
                      {/*  <input type="text" placeholder="City" /> */}
                      <CityDropdown dataList={this.state.cityList} defaultVal = {this.state.city_name} changeCity={this.changeCity}/>
                  </div>

                  <div className="input-icon">
                      <img className="icon" src="/assets/images/r_address.png" />
                      <input type="text" placeholder={languagelist.address} name="address" value={this.state.address} onChange={this.handleChange}/>
                  </div>
                  

                  <div className="input-icon">
                      <img className="icon" src="/assets/images/r_zip.png" />
                      <input type="text" placeholder={languagelist.zip} maxLength="15" name="zipcode" value={this.state.zipcode} onChange={this.handleChange}/>
                  </div>
                  {/* <div className="input-icon">
                      <img className="icon" src="/assets/images/r_phn_icon.png" />
                      <input type="text" placeholder="Dial Code" name="country_dial_code" value={this.state.country_dial_code} readOnly style={{width : "20%"}}/>
                     <input type="text" placeholder={languagelist.mobile} name="phone" maxLength="10" value={this.state.phone} onChange={this.handleChange} style={{width : "80%"}} />
                  </div> */}
                 
                    <div className="input-icon">
                        <img className="icon" src="/assets/images/r_email.png" />
                        <input type="text" placeholder={languagelist.email} name="email" value={this.state.email} onChange={this.handleChange} />
                    </div>
                    
                 { (this.state.membership == "GOLD") ? 
                    <div className="input-icon">
                        <img className="icon" src="/assets/images/r_id.png" style={{top: '4px'}}/>
                        <IdtypeDropdown dataList={this.state.idList} defaultVal = {this.state.id_type} changeId={this.changeId}/>
                    </div>
                    : null
                 }
                 { (this.state.membership == "GOLD") ? 
                    <div className="input-icon">
                        <img className="icon" src="/assets/images/r_id.png" />
                        <input type="text" placeholder={languagelist.idcardd} name="id_type_value" value={this.state.id_type_value} onChange={this.handleChange} />
                    </div>
                    : null
                 }
                 { (this.state.membership == "GOLD") ? 
                    <div className="input-icon">
                        <img className="icon" src="/assets/images/r_career.png" />
                        <input type="text" placeholder={languagelist.career} name="career" value={this.state.career} onChange={this.handleChange} />
                    </div>
                    : null
                 }
                 { (this.state.membership == "GOLD") ? 
                    <div className="input-icon">
                        <img className="icon" src="/assets/images/r_work_position.png" style={{top: '4px'}} />
                        <ProfessionDropdown dataList={this.state.professionList} defaultVal = {this.state.work_title} changeProfession={this.changeProfession}/>
                    </div>
                    : null
                 }
                 { (this.state.membership == "GOLD") ? 
                    <div className="input-icon">
                        <img className="icon" src="/assets/images/r_work_position.png" />
                        <input type="text" placeholder={languagelist.wposition} name="work_position" value={this.state.work_position} onChange={this.handleChange} />
                    </div>
                    : null
                 }
                  <div className="text-center">
                      <button className="user_login_btn" type="submit">{languagelist.registernow}</button>
                      <p className="text-center back-login"><a href="/" style={{color: '#337ab7'}}>{languagelist.backlogin}</a></p>
                  </div>

                  <ul className="bottom_border">
                      <li></li>
                      <li></li>
                  </ul>
              </div>
              </form>       
          </div>
          <p className="text-center copyright_text"> {languagelist.copyright}©BaalDahab, {new Date().getFullYear()}</p>
          
         <VerifyOtp otpmodal={this.state.otpmodal} onOtpSubmit={this.onOtpSubmit} onOtpClose={this.onOtpClose} resend = {this.resend} url_membership={this.state.url_membership}/>
                                    

      </div>

    );
  }
}

const mapStateToProps = state => {

  return {
    
    countryList         : state.countrylist.countryList,
    stateList           : state.statelist.stateList,
    cityList            : state.citylist.cityList,
    registration        : state.signup.signupUser,
    otp                 : state.verifyotp.verifyOtp,
    resend              : state.resendotp.resendOtp,
    idList              : state.idlist.idList,
    professionList      : state.professionlist.professionList,
    
  }
}

const mapDispatchToProps = dispatch => {
  return {
    createLoginRequest         : bindActionCreators(createLoginRequest , dispatch),
    fetchCountryList           : bindActionCreators(fetchCountryList, dispatch),
    fetchStateList             : bindActionCreators(fetchStateList, dispatch),
    fetchCityList              : bindActionCreators(fetchCityList, dispatch),
    basicRegistrationRequest   : bindActionCreators(basicRegistrationRequest, dispatch), 
    goldRegistrationRequest    : bindActionCreators(goldRegistrationRequest, dispatch),
    otoVerification            : bindActionCreators(otoVerification, dispatch),   
    resendotpRequest           : bindActionCreators(resendotpRequest, dispatch),
    fetchProfileIDList         : bindActionCreators(fetchProfileIDList, dispatch), 
    fetchProfileProfessionList : bindActionCreators(fetchProfileProfessionList, dispatch),
    resendemailotpRequest      : bindActionCreators(resendemailotpRequest, dispatch),
  }
}
/* 
RegistrationForm.propTypes = {
  createLoginRequest: PropTypes.func.isRequired,
}; */

export default withRouter(connect(
  mapStateToProps,
  mapDispatchToProps
)(RegistrationForm));